<template>
  <v-app id="app">
    <a href="#main-content" class="skip-link">Vai al contenuto principale</a>
    <v-dialog v-model="showWarningDialog" max-width="500" role="alertdialog">
      <v-card>
        <v-card-title>Informazioni sullo stato del progetto</v-card-title>
        <v-card-text>
          Il progetto EduKanji ha finito il suo ciclo di finanziamento: la manutenzione e gli aggiornamenti sono stati interrotti. Per  informazioni scrivere a <a href="mailto:alessandro.mantelli@unive.it">alessandro.mantelli@unive.it</a>.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showWarningDialog = false">Ho capito</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-main id="main-content">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>

export default {
  data() {
    return {
      showWarningDialog: process.env.VUE_APP_SHOW_WARNING === 'true'
    }
  },
  watch: {
    $route:{
      handler:(to,from)=>{
        document.title = to.meta.title || "Edukanji"
      },
      immediate:true
    }
  }
}
</script>

<style>
#app {
  font-family:'UD デジタル 教科書体 NP-R','Lucida Sans', 'Noto Sans JP','Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
}

.cfbg {
  background: #ad0040!important;
  color:white;
}
.darker {
  background:#940037;
  color:white;
}
.btns {
  background:#d40050!important;
}
.backbtn {
  background:#c70049!important;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000000;
  color: #ffffff;
  padding: 8px 16px;
  z-index: 9999;
  text-decoration: none;
  font-weight: bold;
}
.skip-link:focus {
  top: 0;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
